<template>
    <modal
        id="copy-locations-modal"
        title="Copy Locations"
        ok-title="Copy"
        @ok.prevent="copyLocations"
        :ok-disabled="!selectedProperty"
    >
        <busy-modal :show="busy" />
        <form-select
            label="From Property:"
            v-model="selectedProperty"
            :options="propertyOptions"
        />
    </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatResponseError } from '../../../../utils/api';
import Modal from '../../../generic/modal/modal.vue';
import BusyModal from '../../../generic/busy-modal/busy-modal.vue';
import FormSelect from '../../../generic/form-select/form-select.vue';
export default {
    components: { Modal, BusyModal, FormSelect },
    data() {
        return { busy: false, selectedProperty: '' };
    },
    inject: ['propertyId'],
    computed: { ...mapGetters('setupPropertyStore', ['propertyOptions']) },
    methods: {
        async copyLocations() {
            try {
                this.busy = true;
                const data = await this.$store.dispatch(
                    'setupPropertyStore/copyLocations',
                    {
                        propertyId: this.propertyId,
                        fromPropertyId: this.selectedProperty,
                    }
                );
                this.$bvModal.hide('copy-locations-modal');
                this.$emit('set-locations', data.locations);
                this.successToast({ text: 'Locations successfully copied.' });
            } catch (e) {
                const { generic } = formatResponseError(e);
                this.errorToast({
                    text: generic || 'Could not copy locations.',
                });
            } finally {
                this.busy = false;
            }
        },
    },
};
</script>
